<template lang="pug">
  v-dialog(
    :value="value"
    @input="close"
    max-width="600px"
  )
    v-card.pa-md-4
      v-card-title.headline
        slot(name="header")
          span {{ title }}
        v-spacer
        v-btn(@click="close" icon)
          v-icon mdi-close
      v-card-text.mt-4(class="dialog-text")
        slot
      v-divider
      v-card-actions
        v-checkbox(
          v-model="hidePersist"
          label="Больше не показывать это окно"
        )
        v-spacer
        v-btn(color="warning" @click="close" text rounded) {{ acceptLabel }}
</template>

<script>
export default {
  name: 'TheCookieMessage',
  props: {
    title: { type: String, default: 'Окно приветствия' },
    acceptLabel: { type: String, default: 'Понятно' },
    storageKey: { type: String, default: 'welcome-window' },
  },
  data() {
    return {
      value: false,
      hidePersist: false,
    };
  },
  created() {
    this.checkStorage();
  },
  methods: {
    checkStorage() {
      if (!localStorage.getItem(this.storageKey)) {
        this.show();
      }
    },
    saveStorage() {
      localStorage.setItem(this.storageKey, '1');
    },
    show() {
      this.value = true;
    },
    close() {
      if (this.hidePersist) { this.saveStorage(); }
      this.value = false;
    },
  },
};
</script>
